

























/* tslint:disable:no-console */

import { Component, Vue, PropSync } from 'vue-property-decorator';

@Component({})
export default class LabelSwipe extends Vue {

    @PropSync('guesturelabels') private guestureMap: any;
    private swipeDirection: string = 'None';
    private showInfo: boolean = false;

    private mounted() {
        this.$on('guesture', (guesture: string) => {
            this.swipeDirection = (this.guestureMap as any)[guesture];
            this.showInfo = true;
            setTimeout(() => this.showInfo = false, 1000);
        });
    }

    private swipe(direction: string) {
        this.$emit('guesture', direction);
        this.$emit('swipe', direction);
    }

    private tap() {
        this.$emit('guesture', 'tap');
        this.$emit('tap');
    }

    private longtap() {
        this.$emit('guesture', 'longtap');
        this.$emit('longtap');
    }
}
